import { useSearchParams } from 'react-router-dom'

import { routesManager } from 'utils/routesManager'

export const getGoogleCallbackUrl = () => {
  return `${window.location.origin}${routesManager.googleAuthCallback.url()}`
}

export const useGoogleAuthParams = () => {
  const [searchParams] = useSearchParams()
  const authCode = searchParams.get('code')
  const redirectUri = getGoogleCallbackUrl()

  return { authCode, redirectUri }
}
